import React, { useState, useEffect } from 'react';
import { getProductsSubscriptions, productTypes, generateSquareCheckoutRedirect } from '_services/iap.service';
import { EnumProductsData } from 'types/enums.options';
import CheckoutTable from './components/checkoutTable';
import ProductCard from './components/ProductCard';
import UpgradeSkeleton from './components/upgradeSkeleton';
import { useFetchV2 } from '../../../_core/hooks';
import useAuth from '../../../_core/hooks/useAuth';
import Await from '../../../_core/components/await';
import { User } from '../../../../../common/types/user';
import { getCurrentUser } from '../../../../../common/_services/users.service';

const UpgradeScreen: React.FC = () => {
  const [auth] = useAuth();
  const [selectedProduct, setSelectedProduct] = useState<string | null>(null);
  const [url, setURL] = useState<string>('');
  const [sub, setSub] = useState<string | null>(null); // Store sub as string
  const [loading, setLoading] = useState(true); // Track loading state
  const [loadCheckout, setLoadCheckout] = useState<boolean>(false);

  const [products] = useFetchV2(
    async () => {
      const products = await getProductsSubscriptions(productTypes.WebSquare);
      const links = await generateSquareCheckoutRedirect((products || []).map((x) => x.id));
      return (products || []).map((x) => ({
        ...x,
        'url': (links.find((y) => y.productId == x.id) || { 'url': '/error' }).url,
      }));
    },
    undefined,
    []
  );

  // Fetch current user data
  const fetchUserData = async () => {
    try {
      let currentUserResponse = await getCurrentUser();
      const sub = currentUserResponse.sub;
      setSub(sub); // Set the sub value
      setLoading(false); // Once data is fetched, set loading to false
    } catch (error) {
      console.error('Error fetching current user data:', error);
    }
  };

  useEffect(() => {
    fetchUserData(); // Trigger the function on component mount
  }, []);

  return (
    <div className="d-flex flex-column mobile-vertical-scroll h-100">
      {loadCheckout ? (
        <div className="h-100 d-md-flex bg-checkout">
          {selectedProduct && (
            <div className="flex justify-content-center">
              <Await dependency={products}>
                {(products) => (
                  <CheckoutTable
                    enumProduct={products?.find((x) => x.id === selectedProduct) || products![0]}
                    back={() => {
                      setSelectedProduct(null);
                      setURL('');
                      setLoadCheckout(false);
                    }}
                  />
                )}
              </Await>
              <div>
                <p>
                  Before subscribing to our recurring payment plan, please ensure you review the{' '}
                  <a href="/terms-and-conditions">Terms</a> carefully.
                  Be mindful of renewal dates to avoid any unexpected transactions.
                  <br />
                  <q className="d-flex justify-content-center">
                    <b>Your satisfaction is our priority!</b>
                  </q>
                </p>
              </div>
            </div>
          )}
          <div id="checkout" className="vertical-scroll w-100 m-2" style={{ height: '100vh' }}>
            <iframe
              id="squareCheckout"
              src={url}
              title="Square Iframe"
              style={{ width: '100%', height: '100%', border: 'none' }}
            ></iframe>
          </div>
        </div>
      ) : (
        <div className="h-100">
          {!products || loading ? (
            <UpgradeSkeleton />
          ) : !auth.hasPremium ? (
            <div className="bg-secondary-subtle rounded shadow d-flex flex-column justify-content-evenly h-100">
              <h3 className="text-center pt-3">
                <h2 className="text-center">Unlimited Matches & Messaging</h2>
                <p
                  className="text-center"
                  style={{
				    
                    width: '750px',
                    maxWidth: '90vw',
                    fontSize: '0.6em',
                    margin: '10px auto',
                  }}
                >
                  All currencies converted to US Dollars.
                </p><p style={{
				    width: '600px',
                    maxWidth: '90vw',
                    fontSize: '0.55em',
                    margin: '5px auto',
                  }}>Record answers to 6 short video interview questions for your profile and get 3 months free by emailing support@datingacrossthepond.com</p>
              </h3>

              <style>
                {`
                  .floating-card.product-card-width:nth-of-type(4) {
                    display: none !important;
                  }
                `}
              </style>

              <div className="d-flex flex-wrap flex-md-nowrap gap-3 p-4 mobile-vertical-scroll" style={{ minHeight: '50%' }}>
                {/* Only render the links if sub is available */}
                {sub && (
                  <>
                    <a
                      className="d-flex justify-content-center floating-card w-100 p-3 card pe-auto icon-link product-card-width no-underline-link"
                      href={`https://secure.datingacrossthepond.com/sub/?v=0&sessid=${sub}`} // Correctly embed sub value
                      
                    >
                      <p className="text-center text-black fw-bolder fs-4 m-3">1 Month Full&nbsp;Access</p>
                      <p className="text-center text-black fw-bold fs-4">$34.99</p>
                      <h6 className="text-center">
                        Billed every month until you cancel
                      </h6>
                    </a>

                    <a
                      className="d-flex justify-content-center floating-card w-100 p-3 card pe-auto icon-link product-card-width no-underline-link"
                      href={`https://secure.datingacrossthepond.com/sub/?v=1&sessid=${sub}`} // Correctly embed sub value
                      
                    >
                      <p className="text-center text-black fw-bolder fs-4 m-3">3 Month Full&nbsp;Access</p>
                      <p className="text-center text-black fw-bold fs-4">$74.97</p>
                      <h6 className="text-center">Billed every 3 months until you cancel</h6>
                    </a>

                    <a
                      className="d-flex justify-content-center floating-card w-100 p-3 card pe-auto icon-link product-card-width no-underline-link"
                      href={`https://secure.datingacrossthepond.com/sub/?v=2&sessid=${sub}`} // Correctly embed sub value
                     
                    >
                      <p className="text-center text-black fw-bolder fs-4 m-3">6 Month Full&nbsp;Access</p>
                      <p className="text-center text-black fw-bold fs-4">$107.94</p>
                      <h6 className="text-center">Billed every 6 months until you cancel</h6>
                    </a>
                  </>
                )}
              </div>
            </div>
          ) : (
            <div className="bg-secondary-subtle rounded shadow d-flex flex-column justify-content-evenly h-100">
              <h3 className="text-center pt-3">
                <q className="text-center">Thank you for being a premium member!</q>
                <p className="text-center">Manage your subscription inside your profile</p>
              </h3>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UpgradeScreen;
